// Module
var code = "<terceraButton name=\"link\" visible=\"{{.visible}}\" tooltip=\"{{.tooltip}}\" SVG=\"true\" name=\"{{.btnName}}\" terceraButtonStyle=\"{{.btnClass}}\" on-btnClick=\"linkClick\" checked=\"{{isMenuOpened}}\"/>";
// Exports
export default code;